import { render, staticRenderFns } from "./vendorSection.vue?vue&type=template&id=52c5564f&"
import script from "./vendorSection.vue?vue&type=script&lang=js&"
export * from "./vendorSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports